import React, { createContext, useContext, useState } from 'react';

export const StaticTemplateContext = createContext(null);

export const useStaticTemplateContext = () => {
  const context = useContext(StaticTemplateContext);
  if (!context) {
    throw new Error('useStaticTemplateContext must be used within the StaticTemplateContext');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const StaticTemplateProvider = ({ children, ...otherProps }: IProps) => {
  const [tabsLabel, setTabsLabel] = useState<string>('');

  let contextValue = {
    ...otherProps,
    tabsLabel,
    setTabsLabel,
  };
  return <StaticTemplateContext.Provider value={ contextValue }>{ children }</StaticTemplateContext.Provider>;
};

export default StaticTemplateProvider;
